var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 263,
    viewBox: "0 0 263 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.876 149.448C245.203 149.748 243.533 150.026 241.867 150.281C241.547 151.974 241.308 153.684 240.882 155.356C240.26 153.792 239.513 152.24 238.782 150.729C237.121 150.957 235.464 151.161 233.811 151.344C235.007 150.255 236.209 149.13 237.419 147.969C236.653 146.498 235.811 145.054 235.005 143.651C236.527 144.331 238.046 145.034 239.562 145.758C240.695 144.54 241.898 143.292 242.987 141.997C242.838 143.712 242.573 145.418 242.37 147.129C243.874 147.878 245.41 148.657 246.876 149.448Z",
    fill: "url(#paint0_linear_310_2434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.23 173.915C238.541 173.85 236.86 173.763 235.188 173.655C234.593 175.274 233.81 176.813 233.121 178.393C232.792 176.705 232.483 175.064 232.096 173.432C230.446 173.303 228.745 173.128 227.086 172.945C228.555 172.17 229.895 171.299 231.318 170.424C230.894 168.825 230.46 167.261 229.92 165.698C231.267 166.693 232.608 167.711 233.941 168.749C235.301 167.802 236.675 166.819 238.06 165.802C237.489 167.428 236.996 169.083 236.362 170.684C237.659 171.738 238.948 172.816 240.23 173.915Z",
    fill: "url(#paint1_linear_310_2434)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.498 196.385C226.882 195.97 225.226 195.499 223.612 195.031C222.598 196.424 221.652 197.867 220.58 199.216C220.677 197.538 220.624 195.794 220.622 194.133C219.016 193.638 217.425 193.122 215.846 192.59C217.389 192.106 218.983 191.613 220.546 191.054C220.446 189.381 220.327 187.739 220.191 186.128C221.281 187.384 222.357 188.659 223.422 189.953C224.993 189.344 226.578 188.703 228.102 187.98C227.275 189.492 226.307 190.919 225.384 192.376C226.435 193.691 227.472 195.029 228.498 196.385Z",
    fill: "url(#paint2_linear_310_2434)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.182 215.773C210.677 215.005 209.186 214.219 207.714 213.42C206.492 214.637 205.14 215.71 203.852 216.855C204.261 215.184 204.668 213.566 205.001 211.92C203.557 211.11 202.088 210.241 200.656 209.379C202.315 209.289 203.896 209.06 205.556 208.863C205.848 207.237 206.101 205.626 206.271 203.983C207.075 205.452 207.863 206.937 208.635 208.438C210.27 208.151 211.931 207.838 213.617 207.499C212.417 208.735 211.265 210.019 210.023 211.214C210.761 212.72 211.479 214.238 212.182 215.773Z",
    fill: "url(#paint3_linear_310_2434)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.127 231.263C190.829 230.202 189.525 229.09 188.254 227.987C186.75 228.826 185.29 229.749 183.748 230.52C184.542 229.042 185.222 227.431 185.914 225.921C184.664 224.799 183.434 223.666 182.224 222.522C183.828 222.729 185.478 222.942 187.136 223.094C187.744 221.532 188.322 219.989 188.871 218.468C189.335 220.064 189.781 221.674 190.207 223.295C191.885 223.394 193.599 223.482 195.284 223.461C193.901 224.489 192.42 225.376 190.977 226.316C191.378 227.954 191.762 229.602 192.127 231.263Z",
    fill: "url(#paint4_linear_310_2434)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.178 242.037C168.133 240.705 167.111 239.368 166.109 238.022C164.488 238.61 162.816 239.032 161.161 239.514C162.235 238.168 163.291 236.895 164.278 235.52C163.307 234.175 162.347 232.791 161.408 231.395C162.948 232.005 164.478 232.46 166.067 232.984C167.016 231.64 167.919 230.275 168.762 228.855C168.875 230.525 168.968 232.203 169.039 233.891C170.643 234.317 172.282 234.731 173.955 235.131C172.347 235.75 170.759 236.425 169.135 236.998C169.172 238.67 169.185 240.35 169.178 242.037Z",
    fill: "url(#paint5_linear_310_2434)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.451 247.621C143.719 246.099 143.013 244.6 142.324 243.054L137.17 243.445C138.507 242.355 139.809 241.267 141.073 240.182C140.413 238.632 139.774 237.08 139.158 235.527C140.527 236.402 141.937 237.329 143.37 238.109C144.583 236.96 145.759 235.816 146.899 234.679C146.646 236.318 146.371 237.961 146.074 239.607C147.557 240.44 149.064 241.17 150.606 241.889L148.06 242.335L145.495 242.661C145.169 244.313 144.822 245.966 144.451 247.621Z",
    fill: "url(#paint6_linear_310_2434)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.117 247.796C118.727 246.14 118.361 244.486 118.016 242.834C116.31 242.593 114.589 242.453 112.895 242.128C114.421 241.434 115.937 240.561 117.401 239.774C117.084 238.125 116.79 236.479 116.518 234.837C117.67 235.976 118.858 237.122 120.082 238.273C121.513 237.392 122.907 236.508 124.265 235.624C123.668 237.179 123.049 238.731 122.407 240.282C123.685 241.346 124.994 242.509 126.348 243.495C124.626 243.47 122.912 243.263 121.192 243.156C120.524 244.705 119.831 246.252 119.117 247.796Z",
    fill: "url(#paint7_linear_310_2434)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3278 242.487C94.3017 240.794 94.2973 239.108 94.3147 237.43C92.6702 236.91 91.0735 236.261 89.4711 235.626C91.1402 235.202 92.7441 234.85 94.3712 234.327C94.4147 232.657 94.4785 231.003 94.577 229.316C95.4434 230.709 96.378 232.021 97.327 233.398C98.8933 232.912 100.445 232.345 101.972 231.737C101.052 233.134 100.11 234.527 99.1468 235.91C100.165 237.224 101.219 238.549 102.308 239.883C100.652 239.406 98.9874 238.957 97.34 238.455C96.3577 239.805 95.3536 241.149 94.3278 242.487Z",
    fill: "url(#paint8_linear_310_2434)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2568 231.979C71.5929 230.328 71.9392 228.703 72.3319 227.047L67.9881 224.244C69.7007 224.204 71.4089 224.104 73.0708 224.007C73.4809 222.375 73.9112 220.755 74.3589 219.147C74.9283 220.657 75.4789 222.267 76.1497 223.75C77.8116 223.568 79.4402 223.366 81.0369 223.149C79.843 224.302 78.6303 225.444 77.3972 226.576C78.0768 228.133 78.8317 229.631 79.6257 231.135L77.3291 229.949L75.0877 228.661C73.8301 229.779 72.5536 230.885 71.2568 231.979Z",
    fill: "url(#paint9_linear_310_2434)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.006 216.747C51.6942 215.199 52.3998 213.668 53.1214 212.151C51.8521 210.984 50.6669 209.734 49.4832 208.481C51.1741 208.798 52.7823 209.146 54.4776 209.356C55.2237 207.855 55.9656 206.388 56.7654 204.897C56.9755 206.517 57.2638 208.111 57.5492 209.759C59.1705 209.98 60.8339 210.102 62.4653 210.205C61.044 211.084 59.6052 211.949 58.1491 212.798C58.5185 214.421 58.9141 216.07 59.3386 217.741L55.4338 214.353C53.9748 215.167 52.4983 215.964 51.006 216.747Z",
    fill: "url(#paint10_linear_310_2434)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4725 197.545C35.465 196.189 36.4677 194.853 37.5152 193.513C36.5923 192.058 35.6389 190.621 34.742 189.152C36.3068 189.836 37.9079 190.454 39.4582 191.062C40.513 189.75 41.5809 188.459 42.6603 187.187C42.5458 188.797 42.3777 190.486 42.3604 192.119C43.9469 192.648 45.5117 193.146 47.0533 193.617C45.4871 194.165 43.9063 194.695 42.3125 195.207C42.2807 196.905 42.3328 198.586 42.427 200.281C41.3389 198.944 40.3275 197.548 39.3423 196.136C37.7311 196.622 36.1083 197.093 34.4725 197.545Z",
    fill: "url(#paint11_linear_310_2434)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.455 175.228C23.7301 174.112 25.0123 173.017 26.3033 171.941C25.6412 170.349 25.0819 168.719 24.5415 167.082C25.9353 168.083 27.2567 169.071 28.707 169.974C30.0154 168.923 31.3035 167.905 32.651 166.889C32.1728 168.442 31.7555 170.013 31.3252 171.627C32.7031 172.508 34.1651 173.314 35.6009 174.09C33.9419 174.293 32.2728 174.476 30.5964 174.638C30.2516 176.266 29.9198 177.928 29.6054 179.624L27.4769 174.912C25.8121 175.039 24.1372 175.145 22.455 175.228Z",
    fill: "url(#paint12_linear_310_2434)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5396 150.837C17.0146 150.024 18.4954 149.234 19.979 148.466L19.3183 143.34C20.4746 144.618 21.6264 145.858 22.7725 147.064C24.2866 146.321 25.8036 145.599 27.3221 144.901C26.4991 146.318 25.6877 147.769 24.9778 149.243C26.1919 150.39 27.3699 151.509 28.5913 152.58C26.912 152.422 25.2806 152.232 23.6172 152.025C22.8566 153.553 22.2495 155.089 21.5902 156.673C21.1889 154.997 20.8107 153.316 20.5383 151.613C18.8764 151.376 17.2102 151.118 15.5396 150.837Z",
    fill: "url(#paint13_linear_310_2434)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0105 125.549C15.6086 125.069 17.2691 124.616 18.8933 124.182C19.0382 122.465 19.1208 120.743 19.3193 119.032C20.1277 120.52 21.0536 121.984 21.9186 123.406C23.5501 123 25.1786 122.618 26.8057 122.258C25.7336 123.471 24.6222 124.717 23.5718 126.004C24.5237 127.386 25.4771 128.731 26.429 130.04C24.8468 129.527 23.2646 128.991 21.6824 128.433C20.6725 129.766 19.6076 131.136 18.6875 132.54C18.6021 130.817 18.7325 129.096 18.7498 127.373C17.1691 126.788 15.5883 126.179 14.0105 125.549Z",
    fill: "url(#paint14_linear_310_2434)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 100.508C19.6416 100.391 21.3281 100.295 23.0074 100.222L23.7145 97.7353L24.5432 95.2866C25.0301 96.9224 25.5126 98.5162 26.1138 100.11C27.7859 100.064 29.4492 100.039 31.1097 100.036C29.8144 100.991 28.5089 101.982 27.1918 103.008C27.7497 104.541 28.4495 106.074 29.1102 107.557C27.6671 106.716 26.2283 105.852 24.7954 104.965C23.5334 106.052 22.2612 107.175 20.9818 108.334L22.1439 103.296C20.7239 102.386 19.3446 101.46 17.9507 100.508Z",
    fill: "url(#paint15_linear_310_2434)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2001 76.9012C28.8664 77.1475 30.5239 77.4127 32.1684 77.6996L34.7402 73.2152C34.8895 74.9322 35.0575 76.6187 35.2445 78.2733C36.8991 78.5964 38.5422 78.9384 40.1751 79.3006C38.6668 79.9338 37.1396 80.5974 35.682 81.3407C35.9559 82.9895 36.2094 84.5891 36.5456 86.1858C35.2981 85.0426 34.1143 83.9038 32.9146 82.7316C31.3831 83.4879 29.9806 84.3486 28.4897 85.2078C29.1924 83.6343 29.898 82.0622 30.7123 80.5423C29.5314 79.3499 28.3607 78.1357 27.2001 76.9012Z",
    fill: "url(#paint16_linear_310_2434)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3041 55.849C42.8892 56.4561 44.4583 57.0791 46.0145 57.7195L47.7068 55.7664L49.4817 53.8886C49.2267 55.5679 49.0122 57.2341 48.8818 58.9279C50.4191 59.59 51.9419 60.2681 53.4488 60.9636C51.8695 61.2838 50.2626 61.6316 48.6341 62.0054C48.4935 63.631 48.4993 65.3292 48.4588 66.9432C47.5068 65.5726 46.5679 64.1845 45.6435 62.7791C44.0425 63.234 42.3893 63.6977 40.7665 64.228C41.8011 62.8515 42.8877 61.5127 43.9454 60.1522C43.0312 58.7193 42.1618 57.2935 41.3041 55.849Z",
    fill: "url(#paint17_linear_310_2434)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5984 38.3177C61.0096 39.2392 62.402 40.1737 63.777 41.1213L67.9875 38.1235C67.4051 39.7463 66.8531 41.3488 66.3315 42.931C67.6992 43.9162 69.0481 44.9145 70.3782 45.9258C68.7453 45.8722 67.0776 45.8331 65.4418 45.8983C64.9999 47.511 64.5623 49.0714 64.1972 50.6623C63.5438 49.1004 62.9468 47.5732 62.347 46.0055C60.6402 46.0534 59.0029 46.2432 57.2918 46.3996C58.5885 45.2637 59.8896 44.135 61.2646 43.0947C60.6909 41.5168 60.136 39.923 59.5984 38.3177Z",
    fill: "url(#paint18_linear_310_2434)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2222 25.097C82.4074 26.3112 83.5724 27.5355 84.717 28.77C86.2803 28.0455 87.8568 27.3486 89.4723 26.7444C88.5348 28.16 87.6423 29.5843 86.815 31.0679C87.9335 32.3125 89.0304 33.5673 90.1069 34.8307C88.5392 34.4598 86.9367 34.1019 85.2994 33.7586C84.491 35.1727 83.7868 36.7216 83.0754 38.169C82.7841 36.526 82.5117 34.8728 82.2611 33.208C80.6166 32.9501 78.9243 32.6849 77.2247 32.4821L81.8192 30.1117C81.5859 28.4251 81.3947 26.769 81.2222 25.097Z",
    fill: "url(#paint19_linear_310_2434)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.203 16.8721C106.096 18.3036 106.965 19.7409 107.813 21.1826C109.496 20.8175 111.202 20.5596 112.895 20.2423C111.681 21.4608 110.503 22.6735 109.362 23.8776C110.186 25.3511 110.99 26.8275 111.77 28.3097C110.306 27.5433 108.821 26.8551 107.307 26.2103C106.229 27.4897 105.166 28.6865 104.175 30.0079C104.24 28.3228 104.332 26.6479 104.453 24.9932C102.889 24.334 101.323 23.8109 99.7018 23.2284C101.362 22.7648 103.008 22.2533 104.698 21.9013C104.845 20.2292 105.013 18.5528 105.203 16.8721Z",
    fill: "url(#paint20_linear_310_2434)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.379 13.987C130.943 15.559 131.484 17.1673 132.005 18.7785L137.17 18.9248C135.725 19.8434 134.314 20.8171 132.942 21.7618C133.433 23.3701 133.903 24.9783 134.35 26.5852C133.081 25.5825 131.777 24.5132 130.437 23.5599C129.108 24.5799 127.814 25.5999 126.558 26.6171C126.987 25.0117 127.438 23.4034 127.91 21.7966C126.525 20.8417 125.102 19.8797 123.65 19.0292C125.366 18.8596 127.091 18.8712 128.813 18.8147C129.311 17.205 129.834 15.5953 130.379 13.987Z",
    fill: "url(#paint21_linear_310_2434)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.589 16.5535C155.798 18.2385 155.985 19.9193 156.15 21.5942C157.831 21.9767 159.513 22.352 161.162 22.8562L158.781 23.7197L156.43 24.6949C156.567 26.364 156.682 28.0273 156.774 29.6849C155.752 28.4388 154.692 27.1812 153.597 25.9163C152.096 26.5625 150.599 27.3623 149.158 28.0867C149.918 26.6016 150.704 25.1208 151.509 23.6444C150.354 22.4433 149.168 21.2088 147.939 20.0163L153.031 20.9118C153.865 19.431 154.717 17.985 155.589 16.5535Z",
    fill: "url(#paint22_linear_310_2434)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.66 24.514C179.504 26.1947 179.327 27.8653 179.13 29.5272C180.696 30.2458 182.206 31.079 183.747 31.8498C182.044 32.0845 180.373 32.338 178.736 32.6061C178.501 34.2781 178.247 35.9415 177.972 37.5932C177.271 36.0965 176.5 34.6606 175.689 33.2233C174.056 33.5899 172.491 33.8884 170.896 34.3564C171.962 33.0654 173.059 31.7657 174.154 30.524C173.299 29.0737 172.377 27.6885 171.439 26.2469C173.036 26.896 174.664 27.4654 176.219 28.2116C177.345 26.9699 178.492 25.7369 179.66 24.514Z",
    fill: "url(#paint23_linear_310_2434)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M201.46 37.4463C200.938 39.0632 200.398 40.6686 199.84 42.258C201.187 43.3317 202.574 44.3575 203.853 45.5123C202.178 45.3312 200.464 45.2515 198.785 45.1906C198.205 46.7641 197.607 48.3231 196.993 49.8677C196.593 48.3014 196.165 46.7091 195.709 45.0964C194.044 45.0892 192.381 45.1428 190.764 45.1935C192.078 44.1706 193.412 43.1622 194.764 42.1653C194.221 40.5947 193.698 38.927 193.05 37.3796C194.512 38.2939 195.876 39.353 197.291 40.3325C198.66 39.3588 200.066 38.3764 201.46 37.4463Z",
    fill: "url(#paint24_linear_310_2434)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.94 54.7842C219.094 56.2447 218.233 57.6878 217.358 59.1135C218.477 60.4233 219.502 61.8099 220.579 63.1559C218.933 62.6575 217.31 62.1881 215.709 61.7462C214.796 63.1661 213.871 64.5701 212.929 65.9552C212.917 64.3035 212.82 62.6735 212.684 61.029C211.048 60.6754 209.499 60.2944 207.855 60.048C209.363 59.325 210.906 58.6035 212.422 57.9341C212.251 56.2621 211.997 54.6132 211.751 52.9122C212.926 54.1727 214.166 55.3724 215.266 56.7011C216.809 56.0433 218.368 55.4043 219.94 54.7842Z",
    fill: "url(#paint25_linear_310_2434)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M234.323 75.647C233.172 76.8974 232.01 78.129 230.838 79.3402C231.615 80.879 232.445 82.3902 233.12 83.9767C231.676 83.1088 230.154 82.3192 228.652 81.5614C227.467 82.7466 226.271 83.913 225.066 85.0576C225.358 83.4682 225.635 81.8454 225.896 80.1893C224.392 79.4837 222.855 78.8389 221.365 78.2101C222.988 77.8319 224.621 77.4726 226.267 77.1321C226.429 75.4789 226.649 73.7475 226.713 72.0682C227.652 73.5142 228.453 75.0414 229.33 76.525C230.982 76.2135 232.672 75.9049 234.323 75.647Z",
    fill: "url(#paint26_linear_310_2434)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.832 99.1511C242.449 100.12 241.059 101.068 239.664 101.994C240.161 103.646 240.47 105.344 240.881 107.017C239.602 105.871 238.343 104.757 237.069 103.685C235.655 104.586 234.21 105.471 232.774 106.33C233.47 104.825 234.032 103.317 234.622 101.762C233.3 100.751 232.037 99.7596 230.653 98.8439C232.325 98.8222 234.025 98.8164 235.694 98.8424C236.221 97.2602 236.702 95.652 237.191 94.0046C237.718 95.6447 238.351 97.2516 238.79 98.9192C240.465 98.9758 242.146 99.0525 243.832 99.1511Z",
    fill: "url(#paint27_linear_310_2434)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M248.072 124.14C246.522 124.788 244.976 125.414 243.383 126.018L243.514 131.185C242.492 129.791 241.472 128.435 240.452 127.113C238.871 127.69 237.289 128.245 235.707 128.776C236.639 127.457 237.662 126.096 238.517 124.708C237.43 123.436 236.347 122.198 235.27 120.999C236.894 121.341 238.522 121.704 240.151 122.09L241.468 119.911L242.679 117.688C242.931 119.393 243.046 121.113 243.173 122.832C244.805 123.245 246.438 123.681 248.072 124.14Z",
    fill: "url(#paint28_linear_310_2434)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8045 63.9087C26.6483 101.065 26.6483 161.307 63.8045 198.463C100.961 235.619 161.203 235.619 198.359 198.463C235.515 161.307 235.515 101.065 198.359 63.9087C161.203 26.7526 100.961 26.7526 63.8045 63.9087ZM60.3317 201.936C21.2575 162.862 21.2575 99.5101 60.3317 60.4359C99.4058 21.3618 162.758 21.3618 201.832 60.4359C240.906 99.5101 240.906 162.862 201.832 201.936C162.758 241.01 99.4058 241.01 60.3317 201.936Z",
    fill: "url(#paint29_linear_310_2434)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.084 10.2453C197.771 10.2453 252.025 64.4994 252.025 131.187C252.025 197.874 197.771 252.128 131.084 252.128C64.3964 252.128 10.1423 197.874 10.1423 131.187C10.1423 64.4994 64.3964 10.2453 131.084 10.2453ZM131.084 0.103027C58.6878 0.103027 0 58.7908 0 131.187C0 203.582 58.6878 262.27 131.084 262.27C203.479 262.27 262.167 203.582 262.167 131.187C262.167 58.7908 203.479 0.103027 131.084 0.103027Z",
    fill: "url(#paint30_linear_310_2434)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M176.313 196.997V181.552H183.925C185.646 181.552 187.161 181.868 188.47 182.501C189.779 183.118 190.801 184.001 191.537 185.148C192.272 186.296 192.64 187.664 192.64 189.252C192.64 190.856 192.272 192.238 191.537 193.4C190.801 194.548 189.779 195.438 188.47 196.07C187.161 196.688 185.646 196.997 183.925 196.997H176.313ZM181.52 192.937H183.704C184.439 192.937 185.079 192.797 185.624 192.518C186.183 192.238 186.616 191.826 186.925 191.282C187.234 190.723 187.389 190.047 187.389 189.252C187.389 188.473 187.234 187.811 186.925 187.267C186.616 186.722 186.183 186.31 185.624 186.031C185.079 185.751 184.439 185.612 183.704 185.612H181.52V192.937Z",
    fill: "url(#paint31_linear_310_2434)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M166.233 187.289H173.117V191.039H166.233V187.289ZM166.586 193.069H174.309V196.997H161.467V181.552H174.022V185.479H166.586V193.069Z",
    fill: "url(#paint32_linear_310_2434)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.753 196.997V181.552H158.96V196.997H153.753Z",
    fill: "url(#paint33_linear_310_2434)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.407 188.127H151.203V192.054H144.407V188.127ZM144.76 196.997H139.553V181.552H152.108V185.479H144.76V196.997Z",
    fill: "url(#paint34_linear_310_2434)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M131.84 196.997V181.552H137.047V196.997H131.84Z",
    fill: "url(#paint35_linear_310_2434)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.758 196.997V185.59H116.235V181.552H130.488V185.59H125.965V196.997H120.758Z",
    fill: "url(#paint36_linear_310_2434)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 196.997V181.552H108.614C110.055 181.552 111.298 181.787 112.343 182.258C113.402 182.729 114.218 183.405 114.792 184.288C115.365 185.156 115.652 186.185 115.652 187.377C115.652 188.568 115.365 189.598 114.792 190.466C114.218 191.319 113.402 191.974 112.343 192.43C111.298 192.885 110.055 193.113 108.614 193.113H104.069L106.385 190.973V196.997H101.178ZM110.423 196.997L106.628 191.37H112.144L115.983 196.997H110.423ZM106.385 191.547L104.069 189.186H108.283C109.004 189.186 109.533 189.024 109.871 188.701C110.225 188.377 110.401 187.936 110.401 187.377C110.401 186.818 110.225 186.377 109.871 186.053C109.533 185.729 109.004 185.568 108.283 185.568H104.069L106.385 183.207V191.547Z",
    fill: "url(#paint37_linear_310_2434)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M91.099 187.289H97.983V191.039H91.099V187.289ZM91.4521 193.069H99.1745V196.997H86.3332V181.552H98.8876V185.479H91.4521V193.069Z",
    fill: "url(#paint38_linear_310_2434)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9015 197.351C76.6659 197.351 75.5186 197.159 74.4595 196.777C73.4151 196.38 72.5031 195.821 71.7235 195.1C70.9587 194.379 70.3629 193.526 69.9364 192.541C69.5098 191.555 69.2965 190.467 69.2965 189.275C69.2965 188.084 69.5098 186.995 69.9364 186.01C70.3629 185.024 70.9587 184.171 71.7235 183.45C72.5031 182.729 73.4151 182.178 74.4595 181.795C75.5186 181.398 76.6659 181.2 77.9015 181.2C79.4165 181.2 80.7551 181.464 81.9171 181.994C83.0939 182.524 84.0647 183.288 84.8296 184.289L81.542 187.223C81.086 186.65 80.5786 186.208 80.0196 185.899C79.4754 185.576 78.8576 185.414 78.1662 185.414C77.622 185.414 77.1292 185.502 76.688 185.679C76.2467 185.855 75.8642 186.113 75.5406 186.451C75.2317 186.789 74.989 187.201 74.8125 187.687C74.636 188.157 74.5477 188.687 74.5477 189.275C74.5477 189.864 74.636 190.4 74.8125 190.886C74.989 191.357 75.2317 191.761 75.5406 192.099C75.8642 192.438 76.2467 192.695 76.688 192.872C77.1292 193.048 77.622 193.136 78.1662 193.136C78.8576 193.136 79.4754 192.982 80.0196 192.673C80.5786 192.349 81.086 191.901 81.542 191.327L84.8296 194.262C84.0647 195.247 83.0939 196.012 81.9171 196.556C80.7551 197.086 79.4165 197.351 77.9015 197.351Z",
    fill: "url(#paint39_linear_310_2434)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.312 81.061V65.6162H183.924C185.645 65.6162 187.16 65.9325 188.469 66.565C189.778 67.1828 190.801 68.0653 191.536 69.2127C192.271 70.36 192.639 71.728 192.639 73.3166C192.639 74.9199 192.271 76.3026 191.536 77.4646C190.801 78.6119 189.778 79.5019 188.469 80.1344C187.16 80.7521 185.645 81.061 183.924 81.061H176.312ZM181.519 77.0013H183.703C184.439 77.0013 185.079 76.8615 185.623 76.582C186.182 76.3026 186.616 75.8907 186.925 75.3465C187.234 74.7875 187.388 74.1109 187.388 73.3166C187.388 72.537 187.234 71.8751 186.925 71.3308C186.616 70.7866 186.182 70.3747 185.623 70.0952C185.079 69.8158 184.439 69.676 183.703 69.676H181.519V77.0013Z",
    fill: "url(#paint40_linear_310_2434)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M166.232 71.3529H173.116V75.1038H166.232V71.3529ZM166.585 77.1337H174.307V81.061H161.466V65.6162H174.02V69.5436H166.585V77.1337Z",
    fill: "url(#paint41_linear_310_2434)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M153.751 81.061V65.6162H158.958V81.061H153.751Z",
    fill: "url(#paint42_linear_310_2434)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M144.407 72.1913H151.203V76.1187H144.407V72.1913ZM144.76 81.061H139.553V65.6162H152.107V69.5436H144.76V81.061Z",
    fill: "url(#paint43_linear_310_2434)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M131.839 81.061V65.6162H137.046V81.061H131.839Z",
    fill: "url(#paint44_linear_310_2434)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M120.756 81.061V69.6539H116.233V65.6162H130.486V69.6539H125.963V81.061H120.756Z",
    fill: "url(#paint45_linear_310_2434)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.178 81.061V65.6162H108.613C110.055 65.6162 111.298 65.8516 112.342 66.3223C113.401 66.793 114.217 67.4696 114.791 68.3522C115.365 69.22 115.652 70.2497 115.652 71.4411C115.652 72.6326 115.365 73.6622 114.791 74.5301C114.217 75.3832 113.401 76.0378 112.342 76.4938C111.298 76.9498 110.055 77.1778 108.613 77.1778H104.068L106.385 75.0376V81.061H101.178ZM110.422 81.061L106.627 75.4347H112.143L115.982 81.061H110.422ZM106.385 75.6112L104.068 73.2504H108.282C109.003 73.2504 109.532 73.0886 109.871 72.765C110.224 72.4414 110.4 72.0001 110.4 71.4411C110.4 70.8822 110.224 70.4409 109.871 70.1173C109.532 69.7937 109.003 69.6319 108.282 69.6319H104.068L106.385 67.271V75.6112Z",
    fill: "url(#paint46_linear_310_2434)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0979 71.3529H97.9819V75.1038H91.0979V71.3529ZM91.4509 77.1337H99.1733V81.061H86.3321V65.6162H98.8865V69.5436H91.4509V77.1337Z",
    fill: "url(#paint47_linear_310_2434)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9007 81.4153C76.6651 81.4153 75.5178 81.2241 74.4587 80.8417C73.4143 80.4445 72.5023 79.8856 71.7227 79.1648C70.9579 78.4441 70.3621 77.5909 69.9356 76.6054C69.509 75.6199 69.2957 74.5314 69.2957 73.3399C69.2957 72.1485 69.509 71.06 69.9356 70.0744C70.3621 69.0889 70.9579 68.2358 71.7227 67.515C72.5023 66.7943 73.4143 66.2427 74.4587 65.8602C75.5178 65.4631 76.6651 65.2645 77.9007 65.2645C79.4157 65.2645 80.7543 65.5293 81.9163 66.0588C83.0931 66.5883 84.0639 67.3532 84.8288 68.3535L81.5412 71.288C81.0852 70.7143 80.5778 70.273 80.0188 69.9641C79.4746 69.6405 78.8568 69.4787 78.1654 69.4787C77.6212 69.4787 77.1284 69.567 76.6871 69.7435C76.2459 69.92 75.8634 70.1774 75.5398 70.5157C75.2309 70.854 74.9882 71.2659 74.8117 71.7513C74.6352 72.222 74.5469 72.7515 74.5469 73.3399C74.5469 73.9283 74.6352 74.4652 74.8117 74.9506C74.9882 75.4213 75.2309 75.8258 75.5398 76.1641C75.8634 76.5024 76.2459 76.7598 76.6871 76.9364C77.1284 77.1129 77.6212 77.2011 78.1654 77.2011C78.8568 77.2011 79.4746 77.0467 80.0188 76.7378C80.5778 76.4142 81.0852 75.9655 81.5412 75.3919L84.8288 78.3264C84.0639 79.3119 83.0931 80.0768 81.9163 80.621C80.7543 81.1506 79.4157 81.4153 77.9007 81.4153Z",
    fill: "url(#paint48_linear_310_2434)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M207.309 142.162C207.037 142.162 206.802 142.063 206.604 141.865C206.406 141.667 206.307 141.432 206.307 141.16V126.172L202.152 129.362C201.904 129.536 201.657 129.597 201.41 129.548C201.162 129.474 200.94 129.313 200.742 129.066L197.477 124.836C197.354 124.589 197.317 124.329 197.366 124.057C197.415 123.76 197.564 123.538 197.811 123.389L206.752 116.452C206.876 116.353 206.999 116.291 207.123 116.266C207.247 116.217 207.395 116.192 207.568 116.192H214.58C214.852 116.192 215.087 116.291 215.285 116.489C215.483 116.687 215.582 116.922 215.582 117.194V141.16C215.582 141.432 215.483 141.667 215.285 141.865C215.087 142.063 214.852 142.162 214.58 142.162H207.309Z",
    fill: "url(#paint49_linear_310_2434)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M183.648 142.533C181.793 142.533 180.161 142.298 178.751 141.828C177.341 141.333 176.154 140.665 175.189 139.824C174.225 138.959 173.47 137.957 172.926 136.819C172.407 135.657 172.098 134.395 171.999 133.035C171.949 132.367 171.912 131.551 171.888 130.587C171.888 129.622 171.888 128.657 171.888 127.693C171.912 126.704 171.949 125.863 171.999 125.17C172.098 123.81 172.419 122.561 172.963 121.423C173.532 120.285 174.311 119.308 175.301 118.492C176.29 117.651 177.477 116.996 178.862 116.526C180.272 116.056 181.867 115.821 183.648 115.821C185.429 115.821 187.012 116.056 188.397 116.526C189.806 116.996 191.006 117.651 191.995 118.492C192.985 119.308 193.751 120.285 194.296 121.423C194.864 122.561 195.198 123.81 195.297 125.17C195.347 125.863 195.371 126.704 195.371 127.693C195.396 128.657 195.396 129.622 195.371 130.587C195.371 131.551 195.347 132.367 195.297 133.035C195.198 134.395 194.877 135.657 194.333 136.819C193.813 137.957 193.071 138.959 192.107 139.824C191.142 140.665 189.955 141.333 188.545 141.828C187.135 142.298 185.503 142.533 183.648 142.533ZM183.648 135.261C184.365 135.261 184.872 135.039 185.169 134.593C185.466 134.123 185.627 133.542 185.651 132.85C185.701 132.132 185.726 131.329 185.726 130.438C185.75 129.548 185.75 128.657 185.726 127.767C185.726 126.852 185.701 126.061 185.651 125.393C185.627 124.75 185.466 124.193 185.169 123.723C184.897 123.253 184.39 123.006 183.648 122.981C182.906 123.006 182.399 123.253 182.127 123.723C181.855 124.193 181.694 124.75 181.645 125.393C181.62 126.061 181.595 126.852 181.57 127.767C181.57 128.657 181.57 129.548 181.57 130.438C181.595 131.329 181.62 132.132 181.645 132.85C181.694 133.542 181.867 134.123 182.164 134.593C182.461 135.039 182.955 135.261 183.648 135.261Z",
    fill: "url(#paint50_linear_310_2434)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M157.019 142.533C155.164 142.533 153.532 142.298 152.122 141.828C150.712 141.333 149.525 140.665 148.56 139.824C147.596 138.959 146.841 137.957 146.297 136.819C145.778 135.657 145.469 134.395 145.37 133.035C145.32 132.367 145.283 131.551 145.258 130.587C145.258 129.622 145.258 128.657 145.258 127.693C145.283 126.704 145.32 125.863 145.37 125.17C145.469 123.81 145.79 122.561 146.334 121.423C146.903 120.285 147.682 119.308 148.672 118.492C149.661 117.651 150.848 116.996 152.233 116.526C153.643 116.056 155.238 115.821 157.019 115.821C158.8 115.821 160.383 116.056 161.768 116.526C163.177 116.996 164.377 117.651 165.366 118.492C166.356 119.308 167.122 120.285 167.666 121.423C168.235 122.561 168.569 123.81 168.668 125.17C168.718 125.863 168.742 126.704 168.742 127.693C168.767 128.657 168.767 129.622 168.742 130.587C168.742 131.551 168.718 132.367 168.668 133.035C168.569 134.395 168.248 135.657 167.704 136.819C167.184 137.957 166.442 138.959 165.478 139.824C164.513 140.665 163.326 141.333 161.916 141.828C160.506 142.298 158.874 142.533 157.019 142.533ZM157.019 135.261C157.736 135.261 158.243 135.039 158.54 134.593C158.837 134.123 158.998 133.542 159.022 132.85C159.072 132.132 159.096 131.329 159.096 130.438C159.121 129.548 159.121 128.657 159.096 127.767C159.096 126.852 159.072 126.061 159.022 125.393C158.998 124.75 158.837 124.193 158.54 123.723C158.268 123.253 157.761 123.006 157.019 122.981C156.277 123.006 155.77 123.253 155.498 123.723C155.226 124.193 155.065 124.75 155.016 125.393C154.991 126.061 154.966 126.852 154.941 127.767C154.941 128.657 154.941 129.548 154.941 130.438C154.966 131.329 154.991 132.132 155.016 132.85C155.065 133.542 155.238 134.123 155.535 134.593C155.832 135.039 156.326 135.261 157.019 135.261Z",
    fill: "url(#paint51_linear_310_2434)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M124.275 142.162C124.052 142.162 123.854 142.087 123.681 141.939C123.533 141.766 123.459 141.568 123.459 141.345C123.459 141.222 123.471 141.123 123.496 141.049C123.545 140.974 123.582 140.913 123.607 140.863L128.467 134.371C128.343 134.371 128.244 134.358 128.17 134.334C127.28 134.235 126.315 133.987 125.276 133.592C124.238 133.196 123.248 132.652 122.308 131.959C121.393 131.242 120.639 130.352 120.045 129.288C119.477 128.2 119.192 126.939 119.192 125.504C119.192 124.243 119.439 123.031 119.934 121.868C120.429 120.706 121.171 119.679 122.16 118.789C123.149 117.874 124.374 117.157 125.833 116.637C127.292 116.093 128.986 115.821 130.915 115.821C132.845 115.821 134.551 116.044 136.035 116.489C137.544 116.934 138.805 117.577 139.819 118.418C140.858 119.234 141.637 120.211 142.157 121.349C142.701 122.487 142.973 123.748 142.973 125.133C142.973 126.345 142.725 127.495 142.231 128.583C141.736 129.647 141.118 130.686 140.376 131.7C139.634 132.714 138.867 133.777 138.076 134.89L133.179 141.42C133.08 141.543 132.919 141.704 132.696 141.902C132.474 142.075 132.152 142.162 131.732 142.162H124.275ZM131.027 127.878C131.521 127.878 131.942 127.792 132.288 127.619C132.634 127.421 132.906 127.149 133.104 126.802C133.302 126.432 133.401 125.986 133.401 125.467C133.401 124.948 133.302 124.515 133.104 124.168C132.906 123.797 132.622 123.525 132.251 123.352C131.905 123.154 131.497 123.055 131.027 123.055C130.557 123.055 130.136 123.154 129.765 123.352C129.419 123.525 129.147 123.797 128.949 124.168C128.751 124.515 128.652 124.948 128.652 125.467C128.652 125.986 128.751 126.432 128.949 126.802C129.147 127.149 129.419 127.421 129.765 127.619C130.136 127.792 130.557 127.878 131.027 127.878Z",
    fill: "url(#paint52_linear_310_2434)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.758 142.533C95.3342 142.533 93.2072 142.162 91.3769 141.42C89.5714 140.678 88.1369 139.565 87.0734 138.081C86.0346 136.572 85.4658 134.717 85.3668 132.516C85.3421 131.502 85.3297 130.426 85.3297 129.288C85.3297 128.15 85.3421 127.05 85.3668 125.986C85.4658 123.81 86.0346 121.967 87.0734 120.459C88.1122 118.95 89.5467 117.8 91.3769 117.008C93.2072 116.217 95.3342 115.821 97.758 115.821C100.182 115.821 102.309 116.217 104.139 117.008C105.969 117.8 107.404 118.95 108.443 120.459C109.506 121.967 110.075 123.81 110.149 125.986C110.199 127.05 110.223 128.15 110.223 129.288C110.223 130.426 110.199 131.502 110.149 132.516C110.05 134.717 109.469 136.572 108.406 138.081C107.367 139.565 105.932 140.678 104.102 141.42C102.296 142.162 100.182 142.533 97.758 142.533ZM97.758 135.298C98.5742 135.298 99.2296 135.063 99.7243 134.593C100.219 134.099 100.479 133.332 100.503 132.293C100.553 131.23 100.578 130.179 100.578 129.14C100.578 128.101 100.553 127.075 100.503 126.061C100.479 125.368 100.343 124.799 100.095 124.354C99.8727 123.909 99.5635 123.587 99.1678 123.389C98.7721 123.167 98.3021 123.055 97.758 123.055C97.2386 123.055 96.7687 123.167 96.3482 123.389C95.9525 123.587 95.631 123.909 95.3837 124.354C95.1611 124.799 95.0374 125.368 95.0127 126.061C94.9879 127.075 94.9756 128.101 94.9756 129.14C94.9756 130.179 94.9879 131.23 95.0127 132.293C95.0621 133.332 95.3218 134.099 95.7918 134.593C96.2864 135.063 96.9418 135.298 97.758 135.298Z",
    fill: "url(#paint53_linear_310_2434)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 142.533C68.2547 142.533 65.9917 142.162 64.2109 141.42C62.4301 140.678 61.0945 139.701 60.2042 138.489C59.3138 137.277 58.8438 135.991 58.7944 134.63C58.7944 134.408 58.8686 134.222 59.017 134.074C59.1901 133.901 59.388 133.814 59.6106 133.814H66.6594C67.0552 133.814 67.352 133.876 67.5498 134C67.7724 134.099 68.0074 134.247 68.2547 134.445C68.502 134.618 68.7494 134.779 68.9967 134.927C69.2688 135.051 69.5656 135.15 69.8871 135.224C70.2333 135.274 70.6043 135.298 71.0001 135.298C71.841 135.298 72.5088 135.212 73.0034 135.039C73.5228 134.841 73.7825 134.581 73.7825 134.259C73.7825 133.963 73.6341 133.715 73.3373 133.517C73.0653 133.32 72.583 133.146 71.8904 132.998C71.1979 132.825 70.2333 132.664 68.9967 132.516C67.0428 132.244 65.3486 131.786 63.9141 131.143C62.4796 130.5 61.3666 129.622 60.5751 128.509C59.8084 127.371 59.4251 125.986 59.4251 124.354C59.4251 122.672 59.895 121.188 60.8348 119.902C61.7994 118.616 63.1226 117.614 64.8045 116.897C66.511 116.18 68.4897 115.821 70.7404 115.821C72.5953 115.821 74.2401 116.068 75.6746 116.563C77.1091 117.033 78.321 117.664 79.3103 118.455C80.2996 119.222 81.054 120.05 81.5734 120.941C82.0928 121.831 82.3648 122.684 82.3895 123.501C82.3895 123.723 82.303 123.921 82.1299 124.094C81.9815 124.243 81.8083 124.317 81.6105 124.317H74.1906C73.8443 124.317 73.5599 124.267 73.3373 124.168C73.1395 124.07 72.9292 123.921 72.7066 123.723C72.583 123.6 72.348 123.464 72.0017 123.315C71.6802 123.142 71.2598 123.055 70.7404 123.055C70.122 123.055 69.6645 123.154 69.3677 123.352C69.0956 123.525 68.9596 123.773 68.9596 124.094C68.9596 124.317 69.0709 124.527 69.2935 124.725C69.5161 124.923 69.9242 125.096 70.5178 125.244C71.1114 125.393 71.9646 125.541 73.0776 125.69C75.5509 125.986 77.5295 126.469 79.0135 127.136C80.5222 127.779 81.6105 128.645 82.2783 129.733C82.9708 130.822 83.317 132.17 83.317 133.777C83.317 135.583 82.7729 137.141 81.6847 138.452C80.6211 139.763 79.1619 140.777 77.3069 141.494C75.452 142.186 73.3497 142.533 71.0001 142.533Z",
    fill: "url(#paint54_linear_310_2434)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5102 142.162C47.2381 142.162 47.0032 142.063 46.8053 141.865C46.6075 141.667 46.5085 141.432 46.5085 141.16V117.194C46.5085 116.922 46.6075 116.687 46.8053 116.489C47.0032 116.291 47.2381 116.192 47.5102 116.192H55.0785C55.3505 116.192 55.5855 116.291 55.7834 116.489C55.9812 116.687 56.0802 116.922 56.0802 117.194V141.16C56.0802 141.432 55.9812 141.667 55.7834 141.865C55.5855 142.063 55.3505 142.162 55.0785 142.162H47.5102Z",
    fill: "url(#paint55_linear_310_2434)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7175 101.669C19.7175 100.868 20.3662 100.22 21.1664 100.22H236.015C236.816 100.22 237.464 100.868 237.464 101.669C237.464 102.469 236.816 103.118 236.015 103.118H21.1664C20.3662 103.118 19.7175 102.469 19.7175 101.669Z",
    fill: "url(#paint56_linear_310_2434)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7175 163.972C19.7175 163.171 20.3662 162.523 21.1664 162.523H236.015C236.816 162.523 237.464 163.171 237.464 163.972C237.464 164.772 236.816 165.421 236.015 165.421H21.1664C20.3662 165.421 19.7175 164.772 19.7175 163.972Z",
    fill: "url(#paint57_linear_310_2434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_310_2434",
    x1: 131,
    y1: 0.187009,
    x2: 62.5,
    y2: 300.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d6b70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4A79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ea06c0e2ce076b00471abfe218f22a43.svg";
export { ForwardRef as ReactComponent };